import _extends from '@babel/runtime/helpers/extends';
import React__default, { useMemo } from 'react';
import { HelpTip } from '@amzn/storm-ui';
import { V as ValueTextUrl, C as CustomTag, K as KeyText, a as KeyValueWrapper } from './KeyValueAttribute.styles-6I6Tv0up.js';

const KeyValueAttribute = ({
  id,
  keyText,
  valueText,
  variant = 'default',
  valueUrl,
  helptipText,
  helptipTextPosition = 'right',
  ...rest
}) => {
  // Function to handle custom rendering based on variant
  const renderValue = useMemo(() => {
    if (valueUrl) {
      return /*#__PURE__*/React__default.createElement(ValueTextUrl, {
        href: valueUrl,
        size: "inherit"
      }, valueText);
    }
    switch (variant) {
      case 'inactive':
        return /*#__PURE__*/React__default.createElement(KeyText, null, valueText);
      case 'disable':
        return /*#__PURE__*/React__default.createElement(KeyText, {
          disabled: true
        }, valueText);
      case 'default':
      default:
        return /*#__PURE__*/React__default.createElement(CustomTag, {
          variant: variant,
          label: valueText
        });
    }
  }, [valueUrl, valueText, variant]);
  return /*#__PURE__*/React__default.createElement(KeyValueWrapper, _extends({}, rest, {
    id: id
  }), /*#__PURE__*/React__default.createElement(KeyText, null, keyText, ":"), renderValue, !!helptipText && /*#__PURE__*/React__default.createElement(HelpTip, {
    position: helptipTextPosition
  }, helptipText));
};

export { KeyValueAttribute as K };
//# sourceMappingURL=KeyValueAttribute-BjYR4Ptj.js.map
